import { Rule } from 'antd/lib/form';
import FormSelect from 'components/Select/FormSelect';
import React, { useEffect, useMemo } from 'react';
import { IGetCountries, IItemForGetShortInfo } from 'types';
import { useFetchData } from 'hooks/useFetchData';
import { getCountries } from 'backend/additionalInformation';
import { useTranslation } from 'react-i18next';
import style from './CountrySelect.module.scss';

interface ICountrySelect {
	setIDCountry: (value: Nullable<string>) => void;
	setFetchedCountries: (value: IItemForGetShortInfo[]) => void;
}

const CountrySelect: React.FC<ICountrySelect> = ({ setIDCountry, setFetchedCountries }) => {
	const { response, loading, refetch, responseError } = useFetchData<IGetCountries, null>(getCountries);
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('selectCountry') }], [t]);

	useEffect(() => {
		response && setFetchedCountries(response.data.countries);
	}, [response]);

	return (
		<FormSelect
			containerClassName={style.select}
			testId="CountrySelect"
			name="IDSelectedCountry"
			label="countryLabel"
			options={response?.data.countries}
			fetchError={responseError}
			loading={loading}
			onRefetch={refetch}
			onChange={setIDCountry}
			validationRules={validationRules}
		/>
	);
};

export default React.memo(CountrySelect);
